/** The sparkles the success toast wears (frontend/app/components/icons/emoji/sparkles.hbs). */
export default function IconEmojiSparkles({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" className={className}>
      <path
        d="M9.500 45.750 A14.5 1.25 0 1 0 38.500 45.750 A14.5 1.25 0 1 0 9.500 45.750 Z"
        fill="#45413c"
        opacity=".15"
      />
      <path
        d="M33.7,30.66c.47-1.51,2.06-4,4.08-4.33L46,24.93a.57.57,0,0,0,.53-.49A.56.56,0,0,0,46,24l-8.19-1.41c-2-.34-3.61-2.81-4.08-4.32L31.81,7.59a.75.75,0,0,0-1.32,0L28.6,18.22c-.47,1.51-2.05,4-4.08,4.32L16.33,24a.55.55,0,0,0-.52.49.56.56,0,0,0,.52.49l8.19,1.4c2,.35,3.61,2.82,4.08,4.33l1.89,10.68a.75.75,0,0,0,1.32,0Z"
        fill="#ffe500"
      />
      <path
        d="M46,24l-8.19-1.41c-2-.34-3.61-2.81-4.08-4.32L31.81,7.59a.75.75,0,0,0-1.32,0L29.88,11,31.7,21.28c.47,1.51,2.06,4,4.08,4.32l3.14.54,7-1.21a.57.57,0,0,0,.53-.49A.56.56,0,0,0,46,24Z"
        fill="#fff48c"
      />
      <path
        d="M33.7,30.66c.47-1.51,2.06-4,4.08-4.33L46,24.93a.57.57,0,0,0,.53-.49A.56.56,0,0,0,46,24l-8.19-1.41c-2-.34-3.61-2.81-4.08-4.32L31.81,7.59a.75.75,0,0,0-1.32,0L28.6,18.22c-.47,1.51-2.05,4-4.08,4.32L16.33,24a.55.55,0,0,0-.52.49.56.56,0,0,0,.52.49l8.19,1.4c2,.35,3.61,2.82,4.08,4.33l1.89,10.68a.75.75,0,0,0,1.32,0Z"
        fill="none"
        stroke="#45413c"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.62,16.27c.26-.82,1.13-2.17,2.24-2.36l4.49-.76c.17,0,.29-.14.29-.27s-.12-.24-.29-.27l-4.49-.76A3.54,3.54,0,0,1,14.62,9.5l-1-5.79a.36.36,0,0,0-.36-.21.37.37,0,0,0-.36.21l-1,5.79a3.52,3.52,0,0,1-2.24,2.35l-4.48.76c-.17,0-.29.14-.29.27s.12.24.29.27l4.48.76c1.12.19,2,1.54,2.24,2.36l1,5.81a.36.36,0,0,0,.36.22.35.35,0,0,0,.36-.22Z"
        fill="#ffe500"
        stroke="#45413c"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10,34.83a2.39,2.39,0,0,1,1.54-1.59l3.08-.51a.19.19,0,1,0,0-.37l-3.08-.51A2.41,2.41,0,0,1,10,30.26l-.71-3.9a.29.29,0,0,0-.5,0l-.71,3.9a2.42,2.42,0,0,1-1.53,1.59l-3.09.51a.19.19,0,1,0,0,.37l3.08.51a2.39,2.39,0,0,1,1.54,1.59l.71,3.92a.29.29,0,0,0,.5,0Z"
        fill="#ffe500"
        stroke="#45413c"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
